export const ResourceConstants = {
  ENUM_REQUEST: "COMMEN_ENUM_REQUEST",
  ENUM_SUCCESS: "COMMEN_ENUM_SUCCESS",
  ENUM_FAILURE: "COMMEN_ENUM_FAILURE",

  CREATERESOURCE_REQUEST: "CREATE_RESOURCE_REQUEST",
  CREATERESOURCE_SUCCESS: "CREATE_RESOURCE_SUCCESS",
  CREATERESOURCE_FAILURE: "CREATE_RESOURCE_FAILURE",

  CREATERESOURCEUSER_REQUEST: "CREATE_RESOURCE_USER_REQUEST",
  CREATERESOURCEUSER_SUCCESS: "CREATE_RESOURCE_USER_SUCCESS",
  CREATERESOURCEUSER_FAILURE: "CREATE_RESOURCE_USER_FAILURE",

  UPDATERESOURCE_REQUEST: "UPDATE_RESOURCE_REQUEST",
  UPDATERESOURCE_SUCCESS: "UPDATE_RESOURCE_SUCCESS",
  UPDATERESOURCE_FAILURE: "UPDATE_RESOURCE_FAILURE",

  RESOURCESTATUSCHANGE_REQUEST: "RESOURCE_CHANGE_STATUS_REQUEST",
  RESOURCESTATUSCHANGE_SUCCESS: "RESOURCE_CHANGE_STATUS_SUCCESS",
  RESOURCESTATUSCHANGE_FAILURE: "RESOURCE_CHANGE_STATUS_FAILURE",

};
